import { Link } from "react-router-dom";

export default function PageNotFound() {
  return (
    <div data-id="page-404" className="min-h-screen bg-offwhite flex flex-col items-center justify-center px-6 text-center">
      <p className="font-serif text-9xl text-champagne/30">404</p>
      <h1 className="font-serif text-3xl text-softblack mt-4">Página não encontrada</h1>
      <p className="text-warmgray text-sm mt-2 max-w-md">
        A página que procura não existe ou foi movida.
      </p>
    </div>
  );
}
